import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/map.svg'
import _imports_1 from '@/assets/images/united-states-3.png'
import _imports_2 from '@/assets/images/japan.png'
import _imports_3 from '@/assets/images/australia-2.png'
import _imports_4 from '@/assets/images/germany-2.png'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Sales By Country"),
        _createElementVNode("div", { class: "dropdown action-opt" }, [
          _createElementVNode("button", {
            class: "btn bg-transparent p-0",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { "data-feather": "more-horizontal" })
          ]),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "clock" }),
                _createTextVNode(" Today ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "pie-chart" }),
                _createTextVNode(" Last 7 Days ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "rotate-cw" }),
                _createTextVNode(" Last Month ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "calendar" }),
                _createTextVNode(" Last 1 Year ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "bar-chart" }),
                _createTextVNode(" All Time ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "eye" }),
                _createTextVNode(" View ")
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:;"
              }, [
                _createElementVNode("i", { "data-feather": "trash" }),
                _createTextVNode(" Delete ")
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "text-center",
        style: {"margin":"50px 0"}
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "map"
        })
      ]),
      _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled" }, [
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  style: {"width":"24px"},
                  alt: "facebook"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-12 fw-semibold lh-1" }, "United States")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#ecf0ff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "85",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"85%","height":"8px","background-color":"#757dff"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-14 fw-medium" }, "85%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  style: {"width":"24px"},
                  alt: "japan"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-12 fw-semibold lh-1" }, "Japan")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#ecf0ff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "65",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"65%","height":"8px","background-color":"#0f79f3"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-14 fw-medium" }, "65%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  style: {"width":"24px"},
                  alt: "australia"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-12 fw-semibold lh-1" }, "Australia")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#ecf0ff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "45",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"45%","height":"8px","background-color":"#9135e8"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-14 fw-medium" }, "45%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex align-items-center" }, [
                _createElementVNode("img", {
                  src: _imports_4,
                  style: {"width":"24px"},
                  alt: "germany"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-12 fw-semibold lh-1" }, "Germany")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#ecf0ff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "75",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"75%","height":"8px","background-color":"#25b003"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-14 fw-medium" }, "75%")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}